export const CASE_STUDIES = [
  {
    id: "campus-network",
    title: "Campus Network Overhaul for 18 Buildings",
    excerpt:
      "SD‑WAN, Wi‑Fi 6/6E, and zero‑trust segmentation delivered 47% fewer incidents and 32% higher throughput.",
    date: "2024‑10‑12",
    tags: ["SD‑WAN", "Wi‑Fi 6E", "Zero‑Trust"],
    img: "/resources/case-campus.jpg",
    body: [
      "We modernized a large campus by deploying an SD‑WAN core with automated failover, upgrading access to Wi‑Fi 6/6E, and introducing zero‑trust segmentation.",
      "The design focused on deterministic performance, simplified operations, and an observability stack that tracks user-perceived experience.",
      "Outcome highlights: 47% fewer incidents, 32% higher throughput during peak, and 28% lower operational overhead within the first quarter.",
    ],
  },
  {
    id: "retail-ai-cctv",
    title: "Retail CCTV Modernization with AI Analytics",
    excerpt:
      "Cloud VMS + AI detection reduced false positives by 72% while cutting storage costs by 28%.",
    date: "2024‑07‑04",
    tags: ["AI Video", "Cloud VMS", "Cost Optimization"],
    img: "/resources/case-retail.jpg",
    body: [
      "By migrating VMS to a hybrid-cloud architecture with edge AI, we reduced false positives and centralized policy management.",
      "Adaptive retention and smart indexing cut storage by nearly a third without sacrificing investigative fidelity.",
      "Teams gained faster search, reliable alerting, and unified access control across sites.",
    ],
  },
  {
    id: "industrial-iot-segmentation",
    title: "Industrial IoT: Rugged Edge + Secure Segmentation",
    excerpt:
      "Deterministic latency and OT/IT segmentation improved uptime and audit readiness.",
    date: "2024‑03‑22",
    tags: ["IIoT", "Segmentation", "Resilience"],
    img: "/resources/case-iot.jpg",
    body: [
      "We delivered ruggedized edge nodes with per‑line segmentation and priority queuing for mission-critical PLCs.",
      "OT/IT segmentation was enforced with policy‑as‑code and validated via synthetic probes and golden signals.",
      "The environment achieved higher uptime, faster RCA, and smoother compliance audits.",
    ],
  },
];

export const NEWS = [
  {
    id: "islamabad-innovation-hub",
    title: "Nexite Opens Islamabad Innovation Hub",
    excerpt:
      "A new center focused on AI analytics and secure networking prototypes.",
    date: "2025‑02‑20",
    tags: ["Announcements", "AI", "Networking"],
    img: "/resources/news-hub.jpg",
    body: [
      "Our Islamabad hub accelerates R&D for AI analytics and secure networking reference architectures.",
      "It serves as a customer demo space, lab environment, and training center for hands‑on design reviews.",
    ],
  },
  {
    id: "cloud-vms-partnership",
    title: "Partnership: Cloud VMS + On‑prem Edge",
    excerpt: "Hybrid architectures for compliance and cost control.",
    date: "2024‑12‑05",
    tags: ["Partnership", "Hybrid", "Compliance"],
    img: "/resources/news-partner.jpg",
    body: [
      "We’re partnering to deliver hybrid VMS architectures balancing cost, data residency, and performance.",
      "Edge analytics minimize bandwidth while centralized policies keep operations simple and compliant.",
    ],
  },
  {
    id: "delivery-playbook-v2",
    title: "ISO‑Aligned Delivery Playbook v2",
    excerpt:
      "Continuous improvement in rollout, testing, and verification.",
    date: "2024‑09‑10",
    tags: ["Quality", "Delivery", "Standards"],
    img: "/resources/news-iso.jpg",
    body: [
      "Our updated delivery playbook tightens test procedures, verification gates, and change validation.",
      "The new release improves consistency across multi‑site deployments and reduces mean time to accept.",
    ],
  },
];

export function getResource(type, id) {
  const list = type === "case-studies" ? CASE_STUDIES : type === "news" ? NEWS : [];
  return list.find((x) => x.id === id);
}